import { Col, FormGroup, Label } from "reactstrap";
import clockIcon from "../../../../../assets/images/clock.svg";
import styles from "./index.module.scss";

const InputDate = ({ label, value, id, onChange }) => {
    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            const minutes = [0, 15, 30, 45];
            minutes.forEach((minute) => {
                const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                options.push(timeString);
            });
        }
        return options;
    };

    const handleFormChange = (e) => onChange(e.target.value);

    // Ensure value is never null - convert to empty string if needed
    const safeValue = value || "";

    return (
        <Col md={6} className={`${styles.inputField} px-2`}>
            <FormGroup className="">
                <h5 className="mt-4">
                    <Label htmlFor={id} className={styles.label}>{label}</Label>
                </h5>
                <div className={styles.inputContainer}>
                    <select
                        value={safeValue}
                        onChange={handleFormChange}
                        id={id}
                        className={styles.input}
                    >
                        <option value="">Select Time</option>
                        {generateTimeOptions().map(time => (
                            <option key={time} value={time}>
                                {time}
                            </option>
                        ))}
                    </select>
                    <img className={styles.clock} src={clockIcon} alt="clock" />
                </div>


            </FormGroup>
        </Col>
    )
}

export default InputDate;